import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { ListOrderingIcon } from '@novafuturltd/shared'

interface MenuCategoriesOrderingProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuCategoriesOrdering = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuCategoriesOrderingProps) => {
  const { formatMessage } = useIntl()

  const isDefaultPath = pathname.startsWith('/casino/categories-ordering')

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={`/casino/categories-ordering`}
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <ListOrderingIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.categoriesOrdering.title',
          })}
        />
      </MenuItem>
    </div>
  )
}
